import { Component, ViewEncapsulation, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Data, AppService } from '../../app.service';


// ************************************************** DOWNLOAD APP COMPONENT CLASS ************************************************
@Component({
  selector: 'download-app-page',
  templateUrl: './downloadApp.component.html',
  styleUrls: ['./downloadApp.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DownloadAppComponent implements OnInit {
  public config: SwiperConfigInterface = {};
  constructor(public appService:AppService, 
              public dialogRef: MatDialogRef<DownloadAppComponent>,
              ) { }


  // -- FUNC Ng On Init
  ngOnInit() { }


  // -- FUNC Ng After View Init
  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,         
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true, 
      effect: "fade",
      fadeEffect: {
        crossFade: true
      }
    }
  }


  // -- FUNC Close
  public close(): void {
    this.dialogRef.close();
  }
}
